import { FC, useContext } from 'react'
import styled from 'styled-components'
import NoSSR from 'react-no-ssr'
import { Container, Col, Row, SharingButton, ButtonIcon } from '@mch-group/uikit-components'
import { AddToCollectionContext } from '@components/collections/AddToCollection'
import SalesQueryButton from '../components/SalesQueryButton'
import ArtworkPrice from '../components/ArtworkPrice'
import { useModuleContext } from '../contexts/module'
import GalleryImage from '../components/GalleryImage'
import ArtworkInfo from '../components/ArtworkInfo'
import SeeOnWallOrVideo from '../components/SeeOnWallOrVideo'
import InfoAboveCard from '../InfoAboveCard'

const Content: FC = () => {
  const { showAddToCollectionModal } = useContext(AddToCollectionContext)
  const {
    state: { artworkInformation, labels }
  } = useModuleContext()
  const { id } = artworkInformation || {}

  if (artworkInformation?.id) {
    return (
      <>
        <DisplaceUpDiv className='position-relative'>
          <MainTitleContainer className='px-5 px-lg-8 px-md-7 position-relative'>
            <Row>
              <Col md={9} className='mt-0 offset-lg-1 text-start position-absolute grow-bottom-to-top'>
                <InfoAboveCard />
              </Col>
            </Row>
          </MainTitleContainer>
          {/* Artwork Info */}
          <Container className='px-0 px-sm-3 px-lg-7 px-lg-10 px-lg-7 mb-5'>
            <Row className='bg-white'>
              <Col lg={4} xs={12} className='mb-7 mb-lg-8 mt-9 mt-md-10 mt-lg-11 offset-lg-1 text-start px-7 px-lg-0'>
                <Row>
                  <div className='mb-4 col-md-7 mt-7'>
                    <ArtworkPrice />
                  </div>
                  <SeeOnWallOrVideo forceColumn className='d-none d-lg-block mt-4' />
                  <div className='justify-content-md-end col-12 col-md-5 col-lg-12 d-flex d-lg-block mb-8 mb-md-0'>
                    <div className='d-flex'>
                      <SalesQueryButton />
                      <div className='me-3'>
                        <NoSSR>
                          <SharingButton
                            size='lg'
                            media={[
                              'facebook',
                              'whatsapp',
                              'linkedin',
                              'twitter',
                              'weebo',
                              'wechat',
                              'mail',
                              'link-default'
                            ]}
                            variant='outline'
                          />
                        </NoSSR>
                      </div>
                      <ButtonIcon
                        size='lg'
                        icon='collections-add'
                        variant='outline'
                        //@ts-ignore
                        onClick={() => showAddToCollectionModal(id, '2')}
                        title={labels?.AltTags?.addToCollection}
                      />
                    </div>
                  </div>
                  <div className='d-none d-lg-block mt-lg-10'>
                    <GalleryImage />
                  </div>
                </Row>
                <Row className='d-lg-none'>
                  <SeeOnWallOrVideo />
                </Row>
              </Col>
              <Col lg={6} className='mt-lg-11'>
                {/* <!-- Description + Artwork Details + Logo Image --> */}
                <div className='d-flex  flex-column flex-md-row'>
                  <Row className='order-md-2 offset-md-1 offset-lg-0 mb-10 px-5'>
                    <ArtworkInfo />
                  </Row>
                  <Row className='order-md-1 ms-0 ms-md-0 d-lg-none ps-3 ps-md-0'>
                    <GalleryImage />
                  </Row>
                </div>
              </Col>
            </Row>
            {/* Last row in white card */}
          </Container>
        </DisplaceUpDiv>
      </>
    )
  }
  return null
}

const MainTitleContainer = styled(Container)`
  .grow-bottom-to-top {
    @media (max-width: ${global.uikitVars.breakpointSmMax}) {
      bottom: 56px;
    }

    @media (max-width: ${global.uikitVars.breakpointMdMax}) {
      bottom: 80px;
    }

    @media (min-width: ${global.uikitVars.breakpointLg}) {
      bottom: 100px;
    }
  }
`

const DisplaceUpDiv = styled.div<any>`
  @media (min-width: ${global.uikitVars.breakpointLg}) {
    margin-top: -246px;
  }

  @media (min-width: ${global.uikitVars.breakpointXl}) {
    margin-top: -350px;
  }

  @media (min-width: ${global.uikitVars.breakpointXl}) and (max-height: 720px) {
    margin-top: -100px;
  }
`

export default Content
